import * as React from 'react';
import Box from '@mui/material/Box';
import ImageGallery from 'react-image-gallery';

export default function Gallery(props) {
  const {image} = props.config
  
  return (
    <Box sx={{ width: '100%'}}>
    <ImageGallery 
      ref={props.refImg}
      items={image.gallery} 
      slideInterval={2000}
      slideDuration={350}
      onScreenChange={props.onScreenChange}
      />
    </Box>
  );
}